module.exports = __webpack_public_path__ + "static/media/Boat.svg";